import { createContext, useCallback, useRef, useState } from 'react';

export const TemporaryCellValueRefContext = createContext({});
export const TemporaryCellValueContext = createContext({});

export default function TemporaryCellValueProvider({children}){

  const temporaryCellValueRef = useRef(null);
  const [temporaryCellValue,_setTemporaryCellValue] = useState(null);

  const setTemporaryCellValue = useCallback(value => {

    temporaryCellValueRef.current = value;
    _setTemporaryCellValue(value);

  },[_setTemporaryCellValue])


  const value = { setTemporaryCellValue, temporaryCellValue };


  return (

    <TemporaryCellValueRefContext.Provider value={temporaryCellValueRef}>
      <TemporaryCellValueContext.Provider value={value}>
        {children}
      </TemporaryCellValueContext.Provider>
    </TemporaryCellValueRefContext.Provider>

  )
}
